module.exports = __webpack_public_path__ + "static/media/crearexcusa.eeb57a62.png";